import React from 'react';

import {
  maxValue,
  minValue,
  required,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import InfoPopover from '../../layout/InfoPopover';

const wholeNumber = (value: string | number) => (
  Number.isInteger(Number(value)) ? undefined : 'Must be a whole number'
);

const EntityConnectedAccountCount = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <NumberInput
          fullWidth
          source="ruleParameters.threshold"
          label="Threshold"
          validate={[required(), minValue(1), maxValue(99), wholeNumber]}
          popups={(
            <InfoPopover
              title="Connected account threshold"
              content="Triggers when the entity is connected to more than this many accounts. Accounts declared by the client and accounts observed in transaction activity both count, closed, blocked and inactive accounts included, and there is no time limit on when the connection was seen."
            />
          )}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default EntityConnectedAccountCount;
